export default __webpack_public_path__ + "static/media/image1.d34e01a6.jpg";